import React from 'react';
import SketchEditorScreen from './SketchEditorScreen';

// Simple forwarding component to maintain backward compatibility
// or address potential naming inconsistencies
const SketchScreen = ({ viewOnly = false, isDarkMode = false }) => {
  return <SketchEditorScreen viewOnly={viewOnly} isDarkMode={isDarkMode} />;
};

export default SketchScreen; 